import { useSetAtom } from "jotai";
import { draftReturnAtomFamily } from "../atoms/draft-return.atom";
import { setRebuyRemainingCreditMethod } from "../lib/draft.lib";

export function useSetRebuyRemainingCreditMethod(orderId: string) {
  const setDraft = useSetAtom(draftReturnAtomFamily(orderId));

  return (method: "refund" | "discount") => {
    setDraft((draft) => (draft ? setRebuyRemainingCreditMethod(draft, method) : draft));
  };
}
